
const config = {
    userService: process.env.REACT_APP_USER_SERVICE_URL || 'http://147.79.117.167:8081',
    inquiryService: process.env.REACT_APP_INQUIRY_SERVICE_URL || 'http://localhost:3001',
    categoryService: process.env.REACT_APP_CATEGORY_SERVICE_URL || 'http://192.168.100.2:4000',
  };
  
  export default config;